import { memo as Memo, useEffect, useRef } from 'react';
import gsap from 'gsap/all';

//* Styles
import SeoServiceStyle from './style';
import CustomLottie from '../../CustomLottie';
import SeoServiceLottie from './SeoServiceLottie.json';

const SeoService = Memo(() => {
	const contRef = useRef();

	return (
		<SeoServiceStyle
			ref={contRef}
			className={'SeoServiceCont'}>
			<CustomLottie
				display='flex'
				animData={SeoServiceLottie}
				isStopped={false}
			/>
		</SeoServiceStyle>
	);
});

export default SeoService;
